import Vuex from 'vuex';
import JhiFormatter from './formatter';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import de from 'vuetify/src/locale/de';

import VueCookie from 'vue-cookie';
import Vuelidate from 'vuelidate';
import Vue2Filters from 'vue2-filters';

import * as filters from '@/shared/date/filters';
import { accountStore } from '@/shared/config/store/account-store';
import { translationStore } from '@/shared/config/store/translation-store';
import { appStore } from '@/shared/config/store/app-store/';
import { setupAxiosInterceptors } from '@/shared/config/axios-interceptor';

export function initVueApp(vue) {
  vue.use(VueCookie);
  vue.use(Vuelidate);
  vue.use(Vue2Filters);
  vue.use(Vuetify);

  setupAxiosInterceptors(
    error => {
      const url = error.response?.config?.url;

      const status = error.status || error.response.status;
      if (status === 401) {
        if (!url.endsWith('api/account') && !url.endsWith('api/authenticate')) {
          return;
        }
      }
      console.log('Unauthorized!');
      return Promise.reject(error);
    },
    error => {
      console.log('Server error!');
      return Promise.reject(error);
    }
  );

  filters.initFilters();
}

const messages = {
  de: {
    $vuetify: {
      dataIterator: {
        rowsPerPageText: 'Items per page:',
        pageText: '{0}-{1} of {2}',
      },
    },
  },
};

export function initVueXStore(vue) {
  vue.use(Vuex);
  return new Vuex.Store({
    modules: {
      accountStore,
      translationStore,
      appStore,
    },
  });
}

export function initVuetify(vue) {
  vue.use(Vuetify);
  const opts = {
    theme: {
      dark: false,
      themes: {
        light: {
          primary: '#2E5CC7',
          secondary: '#7A6A4F',
        },
        dark: {
          primary: '#2E5CC7',
          secondary: '#7A6A4F',
        },
      },
    },
  };
  return new Vuetify(opts);
}
